<div class="p-modal-head01">
  <h2 id="modalTitle" class="p-modal-head01__title" [innerHTML]="'label.AnaMileageClub' | staticMsg"></h2>
  <button id="p-login-header-button" class="p-modal-head01__close js-modal-close" (click)="clickClose()">
    <span class="u-visually-hidden" [innerHTML]="'m_static_message-label.close' | staticMsg"></span>
  </button>
</div>
